module.exports = __webpack_public_path__ + "media/images/flags/16/Gibraltar-11518fcf08aa750ff219e06305aa20da.png";